import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    const userString = localStorage.getItem('user');
    let user = null;

    try {
        user = JSON.parse(userString);
    } catch (e) {
        console.error("Error parsing user from localStorage", e);
    }

    // Check if token exists AND user is admin
    if (!token || !user || user.role !== 'admin') {
        // Redirect to Admin Login, not generic login
        return <Navigate to="/admin/login" replace />;
    }

    return children;
};

export default AdminRoute;
